import { ComponentMultiStyleConfig, StyleFunctionProps } from '~/design_system'

/*
 * Slots inherit the container's corners so a slot background does not bleed past
 * the xxl radius. Prefer `border-radius: inherit` over `overflow: hidden` so
 * Menu/Popover inside a slot are not clipped.
 *
 * Header is always top, footer always bottom. Body can be first, last, or both,
 * so it rounds via `_first` / `_last`.
 */
const baseStyle = ({ theme }: StyleFunctionProps) => {
  const partRadius = theme.isSanaRebrand ? 'lg' : 'inherit'
  const headerFooterDivider = theme.isSanaRebrand ? 'none' : '1px solid var(--cnvs-sys-color-border-default)'

  return {
    container: {
      ...theme.layerStyles.card,
      display: 'flex',
      flexDirection: 'column',
      p: theme.isSanaRebrand ? 6 : 0
    },
    header: {
      px: theme.isSanaRebrand ? 0 : 6,
      py: theme.isSanaRebrand ? 0 : 4,
      mb: theme.isSanaRebrand ? 6 : undefined,
      alignItems: 'center',
      borderBottom: headerFooterDivider,
      overflow: theme.isSanaRebrand ? 'visible' : undefined,
      display: 'flex',
      borderTopRadius: partRadius
    },
    body: {
      p: theme.isSanaRebrand ? 0 : 6,
      borderRadius: partRadius,
      overflow: theme.isSanaRebrand ? 'visible' : undefined,
      'header + &': { borderTopRadius: theme.isSanaRebrand ? undefined : 0 },
      '&:has(+ footer)': { borderBottomRadius: theme.isSanaRebrand ? undefined : 0 }
    },
    footer: {
      px: theme.isSanaRebrand ? 0 : 6,
      py: theme.isSanaRebrand ? 0 : 4,
      mt: theme.isSanaRebrand ? 6 : undefined,
      alignItems: 'center',
      borderTop: headerFooterDivider,
      overflow: theme.isSanaRebrand ? 'visible' : undefined,
      display: 'flex',
      borderBottomRadius: partRadius
    }
  }
}

export const Card: ComponentMultiStyleConfig = {
  parts: ['container', 'body', 'header', 'footer'],
  baseStyle,
  sizes: {},
  variants: {
    // Same surface as `layerStyle="cardTonal"` (action bar, filter sidebar).
    tonal: ({ theme }) => ({
      container: { ...theme.layerStyles.cardTonal }
    }),
    // Home StatCard. Softer legacy shadow than Outlined card. Flat under rebrand.
    homeCard: ({ theme }) => ({
      container: {
        p: '2',
        boxShadow: theme.isSanaRebrand ? 'none' : '0px 2px 4px rgba(0, 0, 0, 0.08)'
      }
    })
  },
  defaultProps: {
    size: 'md'
  }
}
